import { render, staticRenderFns } from "./ScreenDetallePedido.vue?vue&type=template&id=58e2ebc9"
import script from "./ScreenDetallePedido.vue?vue&type=script&lang=js"
export * from "./ScreenDetallePedido.vue?vue&type=script&lang=js"
import style0 from "./ScreenDetallePedido.vue?vue&type=style&index=0&id=58e2ebc9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports